import React, { useEffect, useState } from 'react';
import cs from 'classnames';
import * as yup from 'yup';
import { Box } from 'shared/components/display';
import { TagInput } from 'shared/components/molecules/TagInput';
import axiosClient from 'shared/axiosClient';
import { LinkCreator } from 'shared/utilities/linkUtility';
import { Field, Form, Formik, FormikHelpers } from 'formik';
import FormButton from 'shared/components/FormButton';
import Skeleton from 'react-loading-skeleton';
import FieldErrorMessage from 'shared/components/FieldErrorMessage';
import { API_ACCOUNT_MANAGERS_ROUTES } from 'shared/config/routes/api/apiAccountManagerRoutes';

import styles from './styles';

type FetchOptions = () => Promise<string[]>;

export type AccountManagerFormData = {
  names: string[];
};

interface Props {
  onSubmit: (values: AccountManagerFormData) => void;
  initialValues?: AccountManagerFormData;
  accountId: number;
}
const AccountManagerForm: React.FC<Props> = ({ onSubmit: onSubmitProp, initialValues, accountId }) => {
  const [state, setState] = useState<{ loading: boolean; options: string[] }>({
    loading: true,
    options: [],
  });
  const fetchOptions: FetchOptions = async () => {
    try {
      // options are names of all superadmin
      // and all existing account managers
      const { data } = await axiosClient.httpRequest<string[]>({
        url: LinkCreator.createApiLink({
          route: API_ACCOUNT_MANAGERS_ROUTES.ACCOUNT_MANAGER_OPTIONS,
        }),

        method: 'GET',
      });
      setState({
        loading: false,
        options: data.map((name) => name),
      });
      return data;
    } catch (error) {
      console.error('Error fetching account managers:', error);
      setState({ loading: false, options: [] });
      return [];
    }
  };

  const onSubmit = (values: AccountManagerFormData, formikProps: FormikHelpers<AccountManagerFormData>) => {
    onSubmitProp(values);
    formikProps.setSubmitting(false);
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  if (state.loading) {
    return <Skeleton count={1} width="100%" height={30} />;
  }

  return (
    <Box css={styles} className={cs('account-manager-form')}>
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues || defaultValues}
        onSubmit={onSubmit}
        validateOnBlur={false}
        enableReinitialize
      >
        {(formikProps) => (
          <Form>
            <Field
              className="tags-input__tag-input"
              component={TagInput}
              name="names"
              whitelist={state.options}
              placeholder="Select Account Managers"
              showDropdownOnFocus
            />
            <FieldErrorMessage name="names" />
            <FormButton className="account-manager-form__submit-btn">Submit</FormButton>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

const validationSchema = yup.object({
  names: yup.array().of(yup.string().trim()),
});

const defaultValues: AccountManagerFormData = {
  names: [],
};

export default AccountManagerForm;
